@if (loadedError) {
  <app-widgets-overlay [type]="loadedErrorReason"></app-widgets-overlay>
}
@if (!loadedError && loaded && !data) {
  <app-widgets-overlay type="no-match"></app-widgets-overlay>
}
@if (loaded) {
  <div class="widget-container d-flex flex-column">
    <div class="widget-container__object">
      @if (!noTitle) {
        <h1 class="widget-title align-self-center">
          {{ 'web.widget_total_games_tennis' | translate }}
        </h1>
      }
      <div class="d-flex">
        @if (data?.home; as p) {
          <div class="widget-team mt-1 d-flex flex-column" data-cy="team">
            <div class="widget-team__name d-flex align-items-center">
              <img
                (error)="imageError($event)"
                [attr.src]="p.image | responsive: 'participant':'medium'"
                [alt]="p.name"
                class="img-fluid app-cursor mr-1"
                />
              <div>{{ p.name }}</div>
            </div>
          </div>
        }
        @if (data?.away; as p) {
          <div
            class="widget-team mt-1 d-flex flex-column widget-team--second"
            data-cy="team"
            >
            <div class="widget-team__name d-flex align-items-center justify-content-end">
              <div>{{ p.name }}</div>
              <img
                (error)="imageError($event)"
                [attr.src]="p.image | responsive: 'participant':'medium'"
                [alt]="p.name"
                class="img-fluid app-cursor ml-1"
                />
            </div>
          </div>
        }
      </div>
      <div class="d-flex flex-column widget-form-participant-container">
        <div class="d-flex justify-content-between">
          <div class=" ">&nbsp;</div>
          <div class="widget-form-participant-text align-self-end">
            {{ 'web.widget_total_games_tennis_average' | translate }}
          </div>
          <div class=" ">&nbsp;</div>
        </div>
        <div class="d-flex align-content-stretch widget-form-participant--big">
          <div class="widget-form-participant-bar widget-form-participant-bar--home" [style.width.%]="30">
            <span class="widget-form-participant-bar--big2" data-cy="avg-home"
              >{{ homeTotal | number: '1.0-1' }}</span
              >
              <br />
              {{ data?.home?.name }}
            </div>
            <div
              class="widget-form-participant-bar widget-form-participant-bar--uni widget-form-participant-bar--big text-center"
              data-cy="avg-total"
              >
              {{ ( awayTotal + homeTotal) / 2 | number: '1.0-1' }}
              <br />
              <small class="widget-small-text">{{ 'web.win_by_total' | translate }}</small>
            </div>
            <div class="widget-form-participant-bar widget-form-participant-bar--away" [style.width.%]="30">
              <span class="widget-form-participant-bar--big2" data-cy="avg-away"
                >{{ awayTotal | number: '1.0-1' }}</span
                >
                <br />
                {{ data?.away?.name }}
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between mt-4">
            <div class=" ">&nbsp;</div>
            <div class="widget-form-participant-text align-self-end font-weight-bold"></div>
            <div class=" ">&nbsp;</div>
          </div>
          <div class="d-flex flex-column widget-form-participant-container mt-0">
            <div class="d-flex justify-content-between">
              <div class="widget-form-participant widget-form-participant--home1">{{ data?.home?.name }}</div>
              <div class="widget-form-participant widget-form-participant--home2">{{ data?.away?.name }}</div>
            </div>
            <div class="d-flex">
              <div
                class="widget-form-participant-bar widget-form-participant-bar--home1 text-center"
                [style.width.%]="widthHomeTotal"
                >
                {{ homeTotal | number: '1.0-1' }}
              </div>
              <div
                class="widget-form-participant-bar widget-form-participant-bar--home2 text-center"
                [style.width.%]="widthAwayTotal"
                >
                {{ awayTotal | number: '1.0-1' }}
              </div>
            </div>
          </div>
          <div class="w-100 text-center widget-form-participant-text app-word-nowrap">
            {{ 'web.num_of_matches' | translate }} ({{ num }})
          </div>
          <div class="widget-logo d-flex justify-content-center mt-4">
            <img
              [src]="'/img/' + client.getName() + '.png'"
              [alt]="client.getName()"
              data-cy="logo"
              class="widget-logo-client"
              />
          </div>
        </div>
      </div>
    }
